import cookie from 'react-cookie';
import config from '../../config';
import { validateRedemptionCode, redeem } from '../../common/api/redeem';
import { startSubmitSpinner, stopSubmitSpinner } from './interactions';

export const VALIDATE_CODE = 'VALIDATE_CODE';
export const VALIDATE_CODE_SUCCESS = 'VALIDATE_CODE_SUCCESS';
export const VALIDATE_CODE_FAIL = 'VALIDATE_CODE_FAIL';
export const REDEEM = 'REDEEM';
export const REDEEM_SUCCESS = 'REDEEM_SUCCESS';
export const REDEEM_FAIL = 'REDEEM_FAIL';
export const REDEEM_RESET = 'REDEEM_RESET';

export const reset = () => async dispatch => (
  dispatch({ type: REDEEM_RESET })
);

export const validateCode = code => async (dispatch) => {
  try {
    const { company } = config;
    if (!code.length) {
      const error = 'Code cannot be blank.';
      return dispatch({ type: VALIDATE_CODE_FAIL, error });
    }
    const accessToken = cookie.load('access_token');
    dispatch(startSubmitSpinner());
    const { giftProduct, subscription } = await validateRedemptionCode(accessToken, code, company);
    const subscriptionToCredit = subscription && subscription.type === 'stripe' ? subscription : null;
    dispatch(stopSubmitSpinner());
    return dispatch({
      type: VALIDATE_CODE_SUCCESS,
      giftProduct,
      subscription: subscriptionToCredit,
      code
    });
  } catch (err) {
    dispatch(stopSubmitSpinner());
    return dispatch({
      type: VALIDATE_CODE_FAIL,
      error: err.message,
      errorCode: err.code,
    });
  }
};

export const confirmRedemption = code => async (dispatch) => {
  try {
    const { company } = config;
    const accessToken = cookie.load('access_token');
    dispatch(startSubmitSpinner());
    if (!code.length) {
      const error = 'Code cannot be blank.';
      return dispatch({ type: VALIDATE_CODE_FAIL, error });
    }
    const { subscription, accountBalance } = await redeem(accessToken, code, company);
    dispatch(stopSubmitSpinner());
    return dispatch({ type: REDEEM_SUCCESS, subscription, accountBalance });
  } catch (err) {
    dispatch(stopSubmitSpinner());
    return dispatch({
      type: REDEEM_FAIL,
      error: err.message,
      errorCode: err.code,
    });
  }
};
